"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tpfSupplierApiConfig = void 0;
const env_1 = require("../env/env");
exports.tpfSupplierApiConfig = {
    TPF_SUPPLIER_API_BASE_URL: env_1.env.getString('TPF_SUPPLIER_API_BASE_URL') || 'http://localhost:8081',
    TPF_SUPPLIER_API_ADMIN_BASE_URL: env_1.env.getString('TPF_SUPPLIER_API_BASE_URL')
        ? `${env_1.env.getString('TPF_SUPPLIER_API_BASE_URL')}/v2/tpf-api/admin`
        : 'http://localhost:8081/v2/tpf-api/admin',
};
//# sourceMappingURL=tpfSupplierApiConfig.js.map